IfMobileDirective.DIRECTIVE_NAME = 'ktIfMobile';
export default function IfMobileDirective() {
    return {
        multiElement: true,
        transclude: 'element',
        priority: 601,
        terminal: true,
        restrict: 'A',
        require: '^ktScreenDetection',
        link: ($scope, $element, $attr, screenDetectionCtrl, $transclude) => {
            screenDetectionCtrl.registerOnMobile($scope, $element, $transclude);
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/common/screen-detection/if-mobile-directive.js